import { DISCORD_LINK, TELEGRAM_LINK, TWITTER_LINK } from 'utils/constants'
import Status from './Status'
import DiscordIcon from '@components/icons/DiscordIcon'
import { XIcon } from '@components/icons/XIcon'
import { useTranslation } from 'next-i18next'
import { ExternalLink } from '@components/shared/ExternalLink'
import TelegramIcon from '@components/icons/TelegramIcon'

// const DEFAULT_LATEST_COMMIT = { sha: '', url: '' }

const StatusBar = () => {
  const { t } = useTranslation('status-bar')
  // const [latestCommit, setLatestCommit] = useState(DEFAULT_LATEST_COMMIT)

  // useEffect(() => {
  //   const { sha } = latestCommit
  //   if (!sha) {
  //     getLatestCommit().then((commit) => setLatestCommit(commit))
  //   }
  // }, [latestCommit])

  return (
    <div
      className={`fixed bottom-0 z-10 hidden w-full bg-th-bkg-2 px-4 py-1 sm:grid sm:grid-cols-2 md:px-6`}
    >
      <Status />
      {/* <div className="col-span-1 flex items-center justify-center">
        {latestCommit.sha && latestCommit.url ? (
          <Tooltip content="Latest UI commit">
            <ExternalLink
              className="text-xs text-th-fgd-3 focus:outline-none md:hover:text-th-fgd-2"
              href={latestCommit.url}
            >
              {latestCommit.sha}
            </ExternalLink>
          </Tooltip>
        ) : null}
      </div> */}
      <div className="col-span-1 flex items-center justify-end space-x-3 text-xs">
        <div className="flex items-center gap-2">
          <DiscordIcon className="size-4 text-th-fgd-1" />
          <ExternalLink
            className="text-th-fgd-3 focus:outline-none md:hover:text-th-fgd-2"
            href={DISCORD_LINK}
          >
            {t('social.join-discord')}
          </ExternalLink>
        </div>
        <span className="text-th-fgd-4">|</span>
        <div className="flex items-center gap-2">
          <XIcon className="size-4 text-th-fgd-1" />
          <ExternalLink
            className="text-th-fgd-3 focus:outline-none md:hover:text-th-fgd-2"
            href={TWITTER_LINK}
          >
            {t('social.follow-us')}
          </ExternalLink>
        </div>
        <span className="text-th-fgd-4">|</span>
        <div className="flex items-center gap-2">
          <TelegramIcon className="size-4 text-th-fgd-1" />
          <ExternalLink
            className="text-th-fgd-3 focus:outline-none md:hover:text-th-fgd-2"
            href={TELEGRAM_LINK}
          >
            Telegram
          </ExternalLink>
        </div>
      </div>
    </div>
  )
}

export default StatusBar
